import { CustomDomainData } from '../types';

export function setCachedDomainData(domainData: CustomDomainData) {
  localStorage.setItem('domainData', JSON.stringify(domainData));
}
